import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CurrentUserPreferencesContract } from '@core/account-contracts';
import { CurrentUserPreferencesActions, CurrentUserPreferencesSelectors } from '@core/account-data';
import { filterBoolean } from '@core/common-legacy';
import { ThemeUtilsService } from '@core/theme-logic';
import { SupportedThemes, SupportedThemesT, Theme, ThemeName } from '@core/theme-util';

@Injectable({ providedIn: 'root' })
export class CurrentUserPreferencesFacade implements CurrentUserPreferencesContract {
  public activeTheme$: Observable<Theme>;
  public activeThemeName$: Observable<ThemeName>;
  public effectiveThemeName$: Observable<SupportedThemesT>;
  public pipelinePromoteBannerDismissedOfferIds$: Observable<number[]>;

  constructor(private store: Store) {
    this.activeTheme$ = this.store.select(CurrentUserPreferencesSelectors.data).pipe(
      ThemeUtilsService.findEffectiveThemeNameFromPreferences,
      map(themeName => SupportedThemes[<SupportedThemesT>themeName]),
    );

    this.activeThemeName$ = <Observable<ThemeName>>(
      this.store
        .select(CurrentUserPreferencesSelectors.data)
        .pipe(map(data => data?.preferences.theme))
    );

    this.effectiveThemeName$ = this.store
      .select(CurrentUserPreferencesSelectors.data)
      .pipe(ThemeUtilsService.findEffectiveThemeNameFromPreferences);

    this.pipelinePromoteBannerDismissedOfferIds$ = this.store
      .select(CurrentUserPreferencesSelectors.data)
      .pipe(
        filterBoolean,
        map(data => data.preferences.pipelinePromoteBannerDismissedOfferIds),
      );
  }

  public setActiveTheme(themeName: ThemeName): void {
    this.store.dispatch(CurrentUserPreferencesActions.updatePreferredTheme({ payload: themeName }));
  }

  public setPipelinePromoteBannerDismissedOfferIds(offerIds: number[]): void {
    this.store.dispatch(
      CurrentUserPreferencesActions.updatePipelinePromoteBannerDismissedOfferIds({
        payload: offerIds,
      }),
    );
  }
}
